(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('swifStatisticsService', swifStatisticsService);

    /**
        * @ngdoc service
        * @name swif.framework.swifStatisticsService
    **/
    function swifStatisticsService(dataService, userService, gettextCatalog) {
        'ngInject';
        var service = {};
        var currentYear = moment().year();

        // store the inverted array of years in scope (for backward-chronologic sort)
        service.getYears = function (contentType) {
            var years = [];
            // i add manual date at the begining of the array
            years.push({key: 'manual', label: gettextCatalog.getString('Manual Date')});
            // and i add each year from the sooner to the later
            if (contentType) {
                dataService.callKw(
                    contentType,
                    'get_first_year',
                    [],
                    {context: userService.getAuthenticatedUser().context}
                ).then(function (start) {
                    _.forEach(_.range(start, currentYear+1), function (year) {
                        years.push({key: year, label: year});
                    });
                });
            } else {
                _.forEach(_.range(currentYear-7, currentYear+1), function (year) {
                    years.push({key: year, label: year});
                });
            }
            return years;
        };


        service.getYearsButtons = function (contentType) {
            var years = [];
            // to have 10 looping different colors.
            var yearColors = [
                { id: "9", color: "#D4AC0D" },
                { id: "8", color: "#4a27d6" },
                { id: "7", color: "#cab3d6" },
                { id: "6", color: "#d62728" },
                { id: "5", color: "#2ca02c" },
                { id: "4", color: "#ff7f0e" },
                { id: "3", color: "#9467bd" },
                { id: "2", color: "#17becf" },
                { id: "1", color: "#cd651b" },
                { id: "0", color: "#5F6A6A" }
            ];
            var currentYear = moment().format('YYYY');
            if (contentType) {
                dataService.callKw(
                    contentType,
                    'get_first_year',
                    [],
                    {context: userService.getAuthenticatedUser().context}
                ).then(function (start) {
                    _.forEach(_.range(currentYear, start-1, -1), function (year) {
                        var color = yearColors[year % 10].color;
                        years.push({id: year, color: color});
                    });
                });
            } else {
                _.forEach(_.range(currentYear, currentYear-7, -1), function (year) {
                    var color = yearColors[year % 10].color;
                    years.push({id: year, color: color});
                });
            }

            return years;
        }

        service.getDefaultStartPeriod = function () {
            return currentYear.toString() + '-01-01';
        };

        service.getDefaultEndPeriod = function () {
            return currentYear.toString() + '-12-31';
        };

        return service;
    }

})();
